<!--
@Author: MIYONGLE
@Desc: 资讯
@Date: 2021-07-28 13时
-->
<template>
  <div>
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>

    <!-- bannar -->
    <div class="about-bannar">
      <span>新闻中心</span>
      <span>实时掌握行业资讯及企业动态</span>
    </div>

    <!-- 下拉刷新 -->
    <div class="refresh-con">
      <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      class="m-new-main paddingBottom430"
      @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          offset="10"
          finished-text="已经到底了~"
          @load="onLoad"
        >
          <!-- 新闻列表 -->
          <div class="m-new-main-con">
            <div v-for="item in resDataList"
              :key='item.index'
              class="m-new-main-list"
              @click="jumpPage(item.id)"
              >

              <!--带图片-->
              <div v-if="item.titlePic" class="clearfix have-img-block">
                <div>
                  <span>{{item.title}}</span>
                  <span>{{item.createDate}}发布</span>
                </div>
                <img :src="item.titlePic" alt='新闻咨询'/>
              </div>

              <!--不带图片-->
            <div v-else class="no-img-block">
                <span>{{item.title}}</span>
                <span>{{item.createDate}}发布</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  
    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>

  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {getNewAndInfoList} from "../../service/apis";
import {HTTP_CODE} from "../../service/axios_constants";
import {checkNull, changeUrl} from "../../filters/filters";

export default {
  name: "mNews-and-info",
  
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },

  data() {
    return {
      titleName: '资讯',
      source: '',
      resDataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      paramQuery: {
        pageNum: 1,
        pageSize: 10
      },
    }
  },

  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mzx' : '&pageFrom=mzx';
  },

  methods: {

    // 下拉刷新
    onRefresh() {
      this.paramQuery.pageNum = 1
      this.xhrRealTimeInfoList();
      this.refreshing = false;
    },

    //上拉
    onLoad(){
      this.xhrRealTimeInfoList();
    },

    //xhr -- 资讯列表
    xhrRealTimeInfoList(){
      getNewAndInfoList(this.paramQuery).then(res=>{
        if(res.statusCode === HTTP_CODE.suc){
          if (this.paramQuery.pageNum == 1) {
            this.resDataList = res.data.list;
          }
          else {
            res.data.list.forEach(item => {
              this.resDataList.push(item);
            });

            //追加完成后关闭loading
            this.loading = false;
          }

          if (this.paramQuery.pageNum < res.data.totalPageCount) {
            this.paramQuery.pageNum++;
            this.loading = false;
          } else {
            //如果没有数据加载完毕
            this.finished = true;
          }

          for(let item of this.resDataList){
            if(!checkNull(item.titlePic)){
              item.titlePic = changeUrl(item.titlePic)
            }
          }
        }
      });
    },

    //页面跳转
    jumpPage(id){
      var pathTemp,pathName = null;
      var path = window.location.hash;
      pathTemp = path.substring(path.indexOf("?"));
      
      // 如果是带着?source跳转到详情页面的时候也需要带着相应的值
      if(path.indexOf("?source") > 0){
        pathName = path.substring(path.indexOf("=") + 1);
        this.$router.push({
          path: '/mNewsAndInfoDetail?id=' + id + '&source=' + pathName,
        })
      }else{
        this.$router.push({
          path: '/mNewsAndInfoDetail?id=' + id,
        })
      }
    }
  }
}
</script>

<style>
.refresh-con .van-list__error-text, .van-list__finished-text, .van-list__loading{
  font-size: 24px;
  color: #706F6F;
  margin-top: 115px;
  margin-bottom: 195px;
}
.refresh-con .van-pull-refresh__head{
  font-size: 26px;
  color: #706F6F;
}
</style>
<style lang="scss" scoped>

//bannar
.about-bannar{
  width: 100%;
  height: 1080px;
  background: url('../../../static/mobile/mNewsAndInfo/banner_news_1.png') no-repeat top center;
  background-size: 100%;
  background-color: #100f0f;
  color: #FFFFFF;
  span{
    display: block;
  }

  span:nth-child(1){
    font-size: 60px;
    font-weight: 600;
    padding-top: 354px;
  }

  span:nth-child(2){
    font-size: 24px;
    font-weight: 600;
    margin-top: 29px;
  }
}

//下拉刷新
.refresh-con{
  padding: 0 25px;
  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;
}

.m-new-main{
  margin-top: 40px;
  padding-bottom: 50px;
  .m-new-main-con{
    .m-new-main-list:not(:last-child){
      border-bottom: 1.5px solid #e5e5e5;
    }
  }
  .m-new-main-list{
    padding-bottom: 20px;
    margin-top: 15px;
  }

  //带图片
  .have-img-block{
    position: relative;
    div{
      float:left;
      width: 414px;
      margin-right: 20px;

      span{
        display: block;
        text-align: justify;
        font-weight: inherit !important;
      }
      span:nth-child(1){
        font-size: 34px;
        color: #403F3F;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-weight: inherit !important;
      }
      span:nth-child(2){
        font-size: 26px;
        color: #706F6F;
        position: absolute;
        bottom: 10px;
      }
    }
    img{
      float:left;
      width: 266px;
      height: 177px;
      border-radius: 8px;
    }
  }

    //不带图片
  .no-img-block{
    span{
      display: block;
      text-align: justify;
      font-weight: inherit !important;
    }
    span:nth-child(1){
      font-size: 34px;
      color: #403F3F;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-weight: inherit !important;
    }
    span:nth-child(2){
      font-size: 26px;
      color: #706F6F;
      margin-top: 40px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mNewsAndInfo.vue